import { FC, useEffect } from "react";

import { useOfferInsert } from "contexts/InsertOffer";
import useRouter from "hooks/useRouter";
import { DescriptionFormOne } from "./First";
import { DescriptionFormThree } from "./Third";
import { DescriptionSubStep } from "src/types/insertType";
import { DescriptionFormTwo } from "./Second";
import { useAppSelector } from "hooks/reduxHooks";

type DescriptionProps = {
  subStep: DescriptionSubStep;
  setSubStep: (step: DescriptionSubStep) => void;
};

export const Description: FC<DescriptionProps> = ({ setSubStep, subStep }) => {
  const { nextStep, updateStep, getFirstStep } = useOfferInsert();
  const { navigateTo } = useRouter();
  const insertReduxData = useAppSelector((e) => e.insertForm.data);

  useEffect(() => {
    if (!insertReduxData.typeInsert) {
      const step = getFirstStep();
      navigateTo(step.url, {
        id: step.query?.id,
        status: step.query?.status,
        paidId: step.query?.paidId,
      });
    }
  }, []);

  const handleNextComponent = () => {
    updateStep("finished");
    const step = nextStep();
    navigateTo(step.url, {
      id: step.query?.id,
      status: step.query?.status,
      paidId: step.query?.paidId,
    });
  };

  switch (subStep) {
    case "one":
      return (
        <DescriptionFormOne
          buttonNextText="Další"
          handleNextStep={() => setSubStep("two")}
        />
      );
    case "two":
      return (
        <DescriptionFormTwo
          buttonNextText="Další"
          handleNextStep={() => setSubStep("three")}
        />
      );
    case "three":
      return (
        <DescriptionFormThree
          buttonNextText="Další"
          handleNextStep={handleNextComponent}
        />
      );
  }
};
